export const appViews = {
  // ── VideoGuides.vue ──
  guides: {
    openCenter: "Apri il centro guide",
    fabLabel: "Guide",
    assistantAria: "Assistente guide",
    dontShowAgain: "Non mostrare più",
    centerAria: "Centro guide",
    eyebrow: "CENTRO GUIDE",
    title: "Impara WACheckin",
    watchedOf: "{watched} di {total} visti",
    close: "Chiudi",
    searchPlaceholder: "Cerca una guida…",
    forThisScreen: "Per questa schermata",
    watched: "Visto",
    watchGuide: "Guarda la guida",
    comingSoon: "Prossimamente: nuovi miglioramenti e aggiornamenti.",
    noResults: "Nessun risultato per “{query}”.",
    needHelp: "Serve aiuto? ",
    contactWhatsApp: "Scrivici su WhatsApp",
    lightboxMeta: "{section} · Guida {n} di {total}",
    videoTitle: "Video guida",
    playerAria: "Player guida",
    prev: "Precedente",
    watchOnYouTube: "Guarda su YouTube",
    next: "Successivo",
    sections: {
      inicio: "Per iniziare",
      alojamiento: "La tua struttura",
      tarifas: "Tariffe e canali",
      calendario: "Calendario e prenotazioni",
      huesped: "Esperienza dell'ospite",
      autoridades: "Autorità",
      novedades: "Novità",
    },
    videos: {
      navigate: "Accedere e navigare nelle impostazioni",
      propertyData: "Dati, posizione e branding della tua struttura",
      checkinWelcome: "Check-in, messaggio di benvenuto e policy",
      basePrices: "Prezzi base e tariffe derivate dai canali",
      calendar: "Calendario: prenotazioni, disponibilità e prezzi",
      guestJourney: "Il percorso dell'ospite: messaggi, codici e automazioni",
      guestVerification: "Verifica dell'ospite e richieste di recensione",
      authorities: "Collegare le autorità e inviare le comunicazioni dei viaggiatori",
    },
    ai: {
      cta: "Vedi l'elenco dei video",
      assistant: "Assistente",
      inicio: "Primo giorno qui? Ti mostro le basi in 2 minuti.",
      alojamiento: "Stai configurando la tua struttura? Scopri come impostarla alla perfezione.",
      tarifas: "Domande sui prezzi? Ti spiego le tariffe per canale.",
      calendario: "Vuoi padroneggiare il calendario? Prenotazioni, prezzi e disponibilità.",
      huesped: "Automatizziamo il percorso dell'ospite? Ti mostro passo passo.",
      autoridades: "Colleghiamo le autorità? Invia le comunicazioni dei viaggiatori in 1 video.",
    },
  },
  // ── NovedadesDrawer.vue ──
  news: {
    ariaPanel: "Novità del sistema",
    latestUpdates: "Ultimi aggiornamenti",
    close: "Chiudi",
    tabNews: "Novità",
    reports: "Segnalazioni",
    loading: "Caricamento…",
    emptyNews: "Ancora nessuna novità. Vedrai qui i miglioramenti non appena li pubblicheremo.",
    showMore: "Mostra di più",
    showLess: "Mostra di meno",
    reportProblem: "Segnala un problema",
    emptyReports: "Non hai ancora inviato alcuna segnalazione.",
    sendReport: "+ Invia una segnalazione",
    sendNewReport: "+ Invia una nuova segnalazione",
    capturesCount: "{count} screenshot | {count} screenshot",
    viewConversation: "Vedi la conversazione →",
    new: "Nuovo",
    openedOn: "aperta il {date}",
    conversationWithSupport: "Conversazione con il team di supporto",
    you: "Tu",
    support: "Supporto",
    noReplyYet: "Nessuno del team ha ancora risposto. Ti avviseremo qui non appena lo faranno.",
    replyPlaceholder: "Scrivi la tua risposta…",
    send: "Invia",
    replyHint: "<b>Invio</b> invia · <b>Shift + Invio</b> nuova riga",
    back: "Indietro",
    sendReportTitle: "Invia una segnalazione",
    formSubtitle: "Raccontaci cosa è successo e lo esamineremo. Vedrai la risposta nelle tue segnalazioni.",
    about: "Argomento",
    whatHappens: "Cosa succede?",
    titlePlaceholder: "Riassumilo in una frase",
    describeDetail: "Descrivilo in dettaglio",
    descPlaceholder: "Cosa ti aspettavi, cosa è successo e come riprodurlo.",
    capture: "Screenshot",
    optional: "facoltativo",
    attachHint: "Tocca per allegare un'immagine",
    sending: "Invio in corso…",
    submitReport: "Invia segnalazione",
    prev: "Precedente",
    next: "Successivo",
    today: "Oggi",
    yesterday: "Ieri",
    status: {
      open: "Aperta",
      in_progress: "In corso",
      resolved: "Risolta",
      closed: "Chiusa",
    },
    errRequired: "Dicci cosa succede.",
    errSend: "Invio non riuscito. Riprova.",
  },
  // ── VerifyIdentity.vue ──
  verify: {
    title: "Verifica dell'identità",
    subtitle: "Per completare il check-in, dobbiamo verificare la tua identità",
    idDocument: "Documento d'identità",
    idDocumentDesc: "Scatta una foto nitida del fronte del tuo documento (DNI, NIE, carta d'identità, passaporto o patente)",
    selfie: "Selfie",
    selfieDesc: "Scatta un selfie in cui il tuo volto sia ben visibile",
    requirements: "Requisiti:",
    req1: "Buona illuminazione",
    req2: "Documento intero all'interno dell'inquadratura",
    req3: "Testo leggibile",
    req4: "Selfie senza accessori che coprano il volto",
    start: "Avvia la verifica",
    frontTitle: "Fronte del documento",
    alignDocument: "Allinea il documento all'interno dell'inquadratura",
    hintLegible: "Assicurati che tutti i dati siano leggibili",
    faceTitle: "Verifica del volto",
    alignFace: "Allinea il volto all'interno del cerchio",
    hintLookCamera: "Guarda dritto verso la fotocamera senza accessori",
    reviewTitle: "Rivedi le tue foto",
    reviewSubtitle: "Controlla che tutte le immagini siano chiare e leggibili",
    frontDocTitle: "Fronte del documento",
    retake: "Riscatta",
    back: "Indietro",
    submit: "Invia per la verifica",
    processingTitle: "Verifica dell'identità in corso",
    processingDesc: "Stiamo convalidando i tuoi documenti. Potrebbe richiedere qualche secondo...",
    dontClose: "Non chiudere questa finestra",
    successTitle: "Verifica riuscita!",
    successDesc: "La tua identità è stata verificata con successo.",
    continue: "Continua",
    errorTitle: "Errore di verifica",
    couldNotVerify: "Non è stato possibile verificare la tua identità. Riprova.",
    retry: "Riprova",
    cameraErrorTitle: "Impossibile accedere alla fotocamera",
    cameraErrorDesc: "Non è stato possibile accedere alla fotocamera. Controlla i permessi e riprova.",
    suggestions: "Suggerimenti:",
    tip1: "Assicurati di aver concesso i permessi della fotocamera",
    tip2: "Controlla che nessun'altra app stia usando la fotocamera",
    tip3: "Riavvia il browser se il problema persiste",
    tryAgainCamera: "Riprova",
    couldNotVerifyShort: "Non è stato possibile verificare la tua identità",
    serverError: "Errore del server",
    tryLater: "Riprova più tardi",
  },
};
